import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "298",
  "slug": "spot-iran-from-satellite-imagery",
  "title": "How to Recognise Iran in Satellite Images",
  "excerpt": "The Zagros form a belt of ridges across western and southwestern Iran.",
  "date": "2026-04-17",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/iran.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Zagros form a belt of ridges across western and southwestern Iran. The Alborz rise beside the southern Caspian coast, with dry basins in the interior. The change between the Caspian lowlands and the terrain immediately south is useful regional context."
    },
    {
      "type": "heading",
      "text": "The Zagros and the Caspian margin"
    },
    {
      "type": "paragraph",
      "text": "Compare the southern Caspian shore with the plateau beyond the Alborz. Follow where the mountain belt separates those landscapes."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Dry folded ridges continue into Iraq and Turkey. Neither desert colour nor a single ridge identifies Iran. Look for the orientation of several ridges and their position relative to a coast or basin."
    }
  ],
  "imageAlt": "Iran regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
